/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de traslados.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmTraslados from "../../inventarios/FrmTraslados.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmTrasladosPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmTraslados">
      <FrmTraslados />
    </SizeSoftXFrmPortatil>
  );
}
